import { type ClassificacaoItem } from '@fiscoai/contracts';

/**
 * Destino fiscal do item, por extenso. Comum a documentos (classificar o item) e empresas (regras
 * de classificação): por isso mora em `lib/`, não numa feature.
 */
export const CLASSIFICACAO: Record<ClassificacaoItem, string> = {
  REVENDA: 'Revenda',
  INSUMO_INDUSTRIALIZACAO: 'Insumo de industrialização',
  USO_CONSUMO: 'Uso e consumo',
  COMBUSTIVEL: 'Combustível',
  ATIVO: 'Ativo imobilizado',
  INSUMO_SERVICO_COMUNICACAO: 'Insumo de serviço de comunicação',
  SERVICO: 'Serviço',
  // Spec 0009: o nome real vem da classificação da empresa; este é só o rótulo de reserva.
  PERSONALIZADA: 'Da empresa',
};

/** Opções do `Select` de classificação (lista fixa e curta; as da empresa entram à parte). */
export const OPCOES_CLASSIFICACAO = (Object.keys(CLASSIFICACAO) as ClassificacaoItem[])
  .filter((c) => c !== 'PERSONALIZADA')
  .map((c) => ({ valor: c, rotulo: CLASSIFICACAO[c] }));
